import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import GetNewsService from "../../api/News/GetNews/getNewsService";
import DeleteNewsService from "../../api/News/DeleteNews/deleteNewsService";
import { INews } from "./INews";
import { addNewsPath, editNewsPath } from "../../sitemap";
import { imagePath } from "../../context/constant";
import Swal from "sweetalert2";
import toast, { Toaster } from "react-hot-toast";

const NewsList = () => {
  const [newsList, setNewsList] = useState<INews[]>([]);
  const [loading, setLoading] = useState(true);
  const [sortOption, setSortOption] = useState<string>("newest"); // Default sorting option
  const navigate = useNavigate();

  useEffect(() => {
    fetchNews();
  }, []);

  const fetchNews = () => {
    setLoading(true);
    GetNewsService()
      .then((data: INews[]) => setNewsList(data))
      .catch((err) => {
        console.error(err);
        toast.error("Failed to load news");
      })
      .finally(() => setLoading(false));
  };

  const handleDelete = async (id: string) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#ff4d4f",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        await DeleteNewsService(id);
        toast.success("News deleted successfully!");
        fetchNews();
      } catch (error) {
        console.error("Error deleting news:", error);
        toast.error("Failed to delete news.");
      }
    }
  };

  const sortNews = (news: INews[]) => {
    switch (sortOption) {
      case "a-to-z":
        return [...news].sort((a, b) => a.title.localeCompare(b.title));
      case "z-to-a":
        return [...news].sort((a, b) => b.title.localeCompare(a.title));
      case "newest":
        return [...news].sort(
          (a, b) =>
            new Date(b.createdAt || 0).getTime() -
            new Date(a.createdAt || 0).getTime()
        );
      case "oldest":
        return [...news].sort(
          (a, b) =>
            new Date(a.createdAt || 0).getTime() -
            new Date(b.createdAt || 0).getTime()
        );
      case "modified":
        return [...news].sort(
          (a, b) =>
            new Date(b.updatedAt || 0).getTime() -
            new Date(a.updatedAt || 0).getTime()
        );
      default:
        return news;
    }
  };

  return (
    <div style={{ padding: "2rem" }}>
      <Toaster position="bottom-center" reverseOrder={false} />

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "1rem",
        }}
      >
        <button
          onClick={() => navigate(addNewsPath())}
          style={{
            backgroundColor: "#ff7f50",
            color: "#fff",
            border: "none",
            borderRadius: "8px",
            padding: "0.5rem 1rem",
            cursor: "pointer",
          }}
        >
          ➕ Add News
        </button>

        <select
          value={sortOption}
          onChange={(e) => setSortOption(e.target.value)}
          style={{
            padding: "0.5rem",
            borderRadius: "8px",
            border: "1px solid #ccc",
            cursor: "pointer",
          }}
        >
          <option value="newest">Newest First</option>
          <option value="oldest">Oldest First</option>
          <option value="a-to-z">A to Z</option>
          <option value="z-to-a">Z to A</option>
          <option value="modified">Modified Last</option>
        </select>
      </div>

      {loading ? (
        <p>Loading news...</p>
      ) : (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
            gap: "1.5rem",
          }}
        >
          {sortNews(newsList).map((news) => (
            <div
              key={news._id}
              style={{
                border: "1px solid #f8dcdc",
                borderRadius: "12px",
                padding: "1rem",
                backgroundColor: "#fff5f5",
                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)",
                cursor: "pointer",
                position: "relative",
              }}
              onClick={() => navigate(editNewsPath(news._id))}
            >
              <img
                src={
                  news.thumbnail
                    ? imagePath + news.thumbnail
                    : `${imagePath}placeholder_600x400.svg`
                }
                alt={news.title || "News thumbnail"}
                style={{
                  width: "100%",
                  height: "150px",
                  objectFit: "cover",
                  borderRadius: "8px",
                  marginBottom: "0.5rem",
                }}
              />
              <h3 style={{ fontSize: "1.1rem", margin: "0.5rem 0" }}>
                {news.title}
              </h3>
              <p style={{ margin: "0.25rem 0", color: "#333" }}>
                <strong>Author:</strong> {news.author}
              </p>
              <p
                style={{ fontSize: "0.9rem", color: "#555" }}
                dangerouslySetInnerHTML={{
                  __html:
                    news.content.length > 100
                      ? news.content.substring(0, 100) + "..."
                      : news.content,
                }}
              ></p>
              <small style={{ color: "#999" }}>
                Tags: {news.tags?.join(", ")}
              </small>

              <button
                onClick={(e) => {
                  e.stopPropagation();
                  handleDelete(news._id);
                }}
                style={{
                  position: "absolute",
                  bottom: "15px",
                  right: "15px",
                  backgroundColor: "#ff4d4f",
                  border: "none",
                  color: "#fff",
                  borderRadius: "50%",
                  width: "30px",
                  height: "30px",
                  cursor: "pointer",
                }}
                title="Delete News"
              >
                🗑️
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default NewsList;